import React, { useState, useEffect } from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Divider,
  // IconButton,
  // SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  makeStyles,
} from '@material-ui/core';
// import {
//   Edit as EditIcon,
// } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTableCell-head': {
      fontWeight: 700,
      textAlign: 'center',
    },
  },
  queryField: {
    width: 50,
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
}));

function ActionResults({
  className,
  actions,
  pageOfTable,
  setPageOfTable,
  limit,
  setLimit,
  totalActions,
  ...rest
}) {
  const classes = useStyles();
  const [currentActions, setCurrentActions] = useState(actions);

  useEffect(() => {
    setCurrentActions(actions);
  }, [actions]);

  const handlePageChange = (event, newPage) => {
    setPageOfTable(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Divider />
      <Box
        display="flex"
        alignItems="center"
      >
      </Box>
      <PerfectScrollbar>
        <Box minWidth={700}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='center'>
                  Tipo
                </TableCell>
                <TableCell align='center'>
                  Descripción
                </TableCell>
                <TableCell align='center'>
                  Resultado esperado
                </TableCell>
                <TableCell align='center'>
                  Aprobado
                </TableCell>
                <TableCell align='center'>
                  Completado
                </TableCell>
                {/* <TableCell align="right">
                  Acciones
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentActions.map((action) => (
                <TableRow
                  hover
                  key={action.id}
                >
                  <TableCell align='center'>
                    {action.type}
                  </TableCell>
                  <TableCell align='center'>
                    {action.description}
                  </TableCell>
                  <TableCell align='center'>
                    {action.expectedResults}
                  </TableCell>
                  <TableCell align='center'>
                    {action.approved || '-'}
                  </TableCell>
                  <TableCell align='center'>
                    {action.completed || 'No'}
                  </TableCell>
                  {/* <TableCell align="right">
                    <IconButton
                      component={RouterLink}
                      to={`/administracion/actions/${action.id}/editar`}
                    >
                      <SvgIcon fontSize="small">
                        <EditIcon />
                      </SvgIcon>
                    </IconButton>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={totalActions}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={pageOfTable}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Filas por página"
      />
    </Card>
  );
}

ActionResults.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
  pageOfTable: PropTypes.number,
  setPageOfTable: PropTypes.func,
  limit: PropTypes.number,
  setLimit: PropTypes.func,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
  totalActions: PropTypes.number,
};

ActionResults.defaultProps = {
  actions: [],
};

export default ActionResults;
